<template>
    <div class="about-ep">
        <h3 class="indent">Автомобилна индустрия</h3>
        <p class="indent">През 2021 г. беше изградена нова производствена база, предназначена изцяло за автомобилни продукти. Със своето високо автоматизирано, модерно оборудване, доставено от водещи европейски производители, автомобилният завод на Alcomet може да доставя широка гама от компоненти за шасита и части за електрически батерийни модули, изработени от пресовани  алуминиеви  профили.</p>
        <div class="about-ep-table">
          <div class="about-ep-table-row">
            <span>Straight and Angle cutting lines </span>
          </div>
          <div class="about-ep-table-row">
            <span>Punching</span>
          </div>
          <div class="about-ep-table-row">
            <span>4 Axis Double Spindle CNC Machining</span>
          </div>
          <div class="about-ep-table-row">
            <span>Multi-Stations for Washing and Passivation</span>
          </div>
          <div class="about-ep-table-row">
            <span>Flexible Rotating Deburring System</span>
          </div>
          <div class="about-ep-table-row">
            <span>Robotic Deburring Cells</span>
          </div>

          <div class="about-ep-table-row">
            <span> Assembly</span>
          </div>

          <div class="about-ep-table-row">
            <span>Laser Marking </span>
          </div>
          <div class="about-ep-table-row">
            <span>CMM Measurement & Laboratory </span>
          </div>
          <div class="about-ep-table-row">
            <span>Camera control & Detection </span>
          </div>
          <div class="about-ep-table-row">
            <span>Logistics high rack warehouse </span>
          </div>
          <div class="about-ep-table-row">
            <span>Tool management system </span>
          </div>
        </div>
        <img class="about-ep-img" src="/static/img/about/af/2.jpg" alt="Automotive Facility">
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-ep {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.about-ep > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-ep > h3 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-ep-table {
  margin: 15px 0;
  width: 60%;
}
.about-ep-table-row {
  align-items: center;
  background-color: #eef2f8;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 20px;
  width: 100%;
}
.about-ep-table-row-title {
  background-color: transparent;
}
.about-ep-table-row-fifth {
  height: initial;
  min-height: 50px;
  padding: 15px 20px;
}
.about-ep-table-row > span,
.about-ep-table-fifth {
  font-weight: 700;
  font-size: 16px;
  color: #1a437c;
}
.about-ep-table-row-title > span {
  font-weight: 400;
}
.about-ep-table-fifth {
  display: inline-flex;
  justify-content: center;
  text-align: center;
  width: 20%;
}
.about-ep-img {
  border-radius: 5px;
  height: auto;
  margin: 20px auto;
  min-height: 1px;
  width: 80%;
}
.colors {
  display: flex;
  margin: 15px 0;
}
.color {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.color-square {
  border-radius: 6px;
  height: 8vw;
  margin: 10px;
  width: 8vw;
}
@media screen and (max-width: 1000px) {
  .about-ep p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-ep-table,
  .about-ep > h3 {
    width: 100%;
    padding: 0 30px;
  }
  .about-ep-img {
    width: calc(100% - 60px);
  }
  .color > span {
    font-size: 12px;
  }
}
@media screen and (max-width: 600px) {
  .about-ep-table-row > span,
  .about-ep-table-fifth {
    font-size: 12px;
  }
  .about-ep-table-row-fifth {
    padding: 15px;
  }
  .colors {
    flex-direction: column;
    padding: 0 30px;
    width: 100%;
  }
  .color {
    flex-direction: row;
  }
  .color-square {
    height: 10vw;
    width: 10vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/AutomotiveFacility.vue